import React from 'react';
import swal from 'sweetalert';
import useProfile from '../../../Hooks/useProfile';

const ProfileLeft = () => {
    const [user] = useProfile();

    //contact btn
    const sendMessage = () => {
        swal('Success', 'Message me on the number below', 'success')
    }

    //contact btn
    const sendEmail = () => {
        swal('Success', 'Message me on the Email below', 'success')
    }

    return (
        <div>
            <div className="shadow-lg p-3 rounded">
                <div className="profile-details">
                    <div className="profile-logo">
                        <img src={user?.profile} alt={user?.name} className='img-fluid rounded-pill d-block mx-auto' style={{ height: '70px', width: '70px' }} />
                        <h5 className='text-center mt-2 mb-3 text-capitalize'>{user?.name}</h5>
                    </div>
                    <div className="contact-btn d-flex align-items-center justify-content-center d-flex">
                        <button className="btn btn-primary" onClick={sendMessage}>Message</button>
                        <button className="btn btn-outline-danger ms-2" onClick={sendEmail}>Contact</button>
                    </div>
                    <hr />
                    <div className="extra-profile">
                        <h6>Full Name : <span className='ms-5 text-capitalize'>{user?.name}</span></h6>
                        <hr />
                        <h6>Email : <span className='ms-5'>{user?.email ? user?.email : 'mala'}</span></h6>
                        <hr />
                        <h6>Mobile : <span className='ms-5'>{user?.phone ? user?.phone : 'Add your phone'}</span></h6>
                        <hr />
                        <h6>Present Address : <span className='ms-5 text-capitalize'>{user?.presentAddress ? user?.presentAddress : 'Add your address'}</span></h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileLeft;